<template>
    <div>
        <LoadingScreen v-if="isLoadingScreen"></LoadingScreen>
        <div class="loto__list__container" v-else>
            <div class="loto__list__head__container">
                <div class="loto__list__logo">
                    <img src="~ThemePath/images/logo.png" />
                </div>
                <div class="loto__list__head">
                    <div class="loto__list__head__name">
                        {{ getTranslatedText(`guinne ${ dataDetail.title }`) }}
                    </div>
                    <div class="loto__list__head__title">{{ dataDetail.title }} {{ dataDetail.gameNumber }}</div>
                    <div class="loto__list__head__sub__title">
                        {{ getTranslatedText('Select Event') }}
                    </div>
                    <div class="loto__list__head__button">
                        <button @click="onSelectAll">{{ getTranslatedText('Select All') }}</button>
                    </div>
                </div>
            </div>
            <!-- FreeBet: a coupon grants N spins; the cashier must place all N now and
                 may stack several on the same draw. Show progress + per-draw count. -->
            <div v-if="freebetActive" class="loto__list__freebet-hint" :class="{ 'is-complete': eventSelect.length === freebetMaxDraws }">
                {{ getTranslatedText('freebet select draws', { number: freebetMaxDraws }) }}
                <span class="loto__list__freebet-hint__count">{{ eventSelect.length }} / {{ freebetMaxDraws }}</span>
            </div>
            <div class="loto__list__items">
                <div class="loto__list__item g590" :class="{ active: eventSelect.includes(v.event_id) }" v-for="(v, i) in dataEvents" :key="i" @click="onSelectEvent(v.event_id, v)">
                    <div class="loto__list__item__name">
                        {{ v.draw_name }}
                    </div>
                    <div class="loto__list__item__time">
                        {{ renderDate(v.draw_date) }}
                    </div>
                    <div v-if="freebetActive" class="loto__list__item__freebet">
                        <span v-if="drawCount(v.event_id) > 0" class="loto__list__item__count" @click.stop="onRemoveFreebetDraw(v.event_id)">
                            ×{{ drawCount(v.event_id) }}
                        </span>
                        <!-- TODO: +N fill button temporarily hidden per request; remove `false &&` to restore -->
                        <span v-if="false && freebetRemainingToPick > 0" class="loto__list__item__fill" @click.stop="onFillFreebetDraw(v.event_id, v)">
                            +{{ freebetRemainingToPick }}
                        </span>
                    </div>
                </div>
                <div class="loto__list__buttons">
                    <div class="loto__list__button__back" @click="handleBack()">
                        <button>{{ getTranslatedText('Back') }}</button>
                    </div>
                    <div class="loto__list__button__continue" :class="{ 'is-disabled': freebetActive && eventSelect.length !== freebetMaxDraws }" @click="handleContinue">
                        <button>{{ getTranslatedText('Continue') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoadingScreen from '@/components/common/loading/index.vue'
import languageMixins from '@/mixins/language/language-mixins'
import GamesService from '@/services/games.service'
import LastResultService from '@/services/last-result.service'
import EventBus from '@/utils/EventBus'
import ButtonCommon from '@/components/common/button/index.vue'
import { formatPrice, isSameDay, isArrayEmpty, formatDateUTC00, isStrEmpty } from '@/utils/utils'
const WAGER_MIN_ENV = process.env.VUE_APP_WAGER_MIN || 2000

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, LoadingScreen },
    data() {
        return {
            dataDetail: {},
            eventSelect: [],
            eventInfo: [],
            isLoadingScreen: true,
        }
    },
    computed: {
        freebetActive() {
            return !!this.$store.state.freebetContext
        },
        // Spins already committed to the 5/90 betslip (one bet per selected event).
        freebetSpinsInCart() {
            return (this.$store.state.transact || []).reduce(
                (sum, e) => sum + ((e.event_id && e.event_id.length) || 1),
                0
            )
        },
        // FreeBet: a coupon grants N spins; each selected draw consumes one. Cap the
        // draw selection at what's left so the cashier can't build an invalid sequence.
        freebetMaxDraws() {
            const ctx = this.$store.state.freebetContext
            const total = ctx ? parseInt(ctx.remaining, 10) || 0 : 0
            return Math.max(total - this.freebetSpinsInCart, 0)
        },
        // Spins still to place before the coupon is fully claimed.
        freebetRemainingToPick() {
            return Math.max(this.freebetMaxDraws - this.eventSelect.length, 0)
        },
    },
    created() {
        let dataDetail = localStorage.getItem('game-loto')
        if (isStrEmpty(dataDetail)) {
            this.$router.push('/loto')
        }
        this.dataDetail = JSON.parse(dataDetail)
        this.fetchDataDetail()
    },
    destroyed() {},
    methods: {
        async fetchDataDetail() {
            try {
                const resp = await GamesService.getListEvents('multi-lotto')
                const respGames = await GamesService.getListGames('multi-lotto')
                LastResultService.writeScheduleFromGames('multi-lotto', respGames)
                if (resp.code === 200) {
                    this.dataEvents = resp.data
                    this.$store.dataListEvents = resp.data
                    this.isLoadingScreen = false
                }
            } catch (error) {
                this.isLoadingScreen = false
                console.log(error)
            }
        },

        handleContinue() {
            if (isArrayEmpty(this.eventSelect)) {
                const param = {
                    text: 'Please choose the game',
                    type: 'warning',
                }
                EventBus.$emit('show-notications', param)

                return false
            }
            // FreeBet: the coupon must be claimed in full in one go — every spin has
            // to be placed on a draw before moving on (stacking allowed).
            if (this.freebetActive && this.eventSelect.length !== this.freebetMaxDraws) {
                EventBus.$emit('show-notications', {
                    text: this.getTranslatedText('freebet select all draws', { number: this.freebetMaxDraws }),
                    type: 'warning',
                })
                return false
            }
            let dataNumber = {
                game: this.dataDetail.name,
                title: this.dataDetail.title,
                gameNumber: this.dataDetail.gameNumber,
                event_id: this.eventSelect,
                numberQp: this.dataDetail.numberQp,
                eventInfo: this.eventInfo,
                selection: [],
                draws: 1,
                wager: this.dataDetail.price,
                isPariMutuelLotto: false,
                priceNumber: this.renderPrice(WAGER_MIN_ENV, 0),
                defaultWager: this.renderPrice(WAGER_MIN_ENV, 0),
                allowedPicks: this.dataDetail.allowedPicks,
                betOptions: this.dataDetail.betOptions,
            }
            localStorage.setItem('loto-number', JSON.stringify(dataNumber))
            this.$router.push('/loto-number')
        },

        onSelectAll() {
            if (this.dataEvents.length === this.eventSelect.length) {
                this.eventSelect = []
                this.eventInfo = []
            } else {
                this.dataEvents.forEach((item) => {
                    const index = this.eventSelect.findIndex((x) => x === item.event_id)
                    if (index === -1) {
                        // FreeBet: stop adding once the remaining-spins cap is reached.
                        if (this.freebetActive && this.eventSelect.length >= this.freebetMaxDraws) {
                            return
                        }
                        this.eventSelect.push(item.event_id)
                        this.eventInfo.push({
                            name: item.draw_name,
                            date: item.draw_date,
                        })
                    }
                })
                if (this.freebetActive && this.dataEvents.length > this.freebetMaxDraws) {
                    EventBus.$emit('show-notications', {
                        text: this.getTranslatedText('freebet too many spins') + ' (' + this.freebetMaxDraws + ')',
                        type: 'warning',
                    })
                }
            }
        },

        onSelectEvent(eventId, item) {
            // FreeBet: each tap adds one spin (stacking on the same draw is allowed).
            // Removal is via the ×N badge, not by re-tapping the row.
            if (this.freebetActive) {
                if (this.eventSelect.length >= this.freebetMaxDraws) {
                    EventBus.$emit('show-notications', {
                        text: this.getTranslatedText('freebet too many spins') + ' (' + this.freebetMaxDraws + ')',
                        type: 'warning',
                    })
                    return
                }
                this.eventSelect.push(eventId)
                this.eventInfo.push({
                    name: item.draw_name,
                    date: item.draw_date,
                })
                return
            }
            const index = this.eventSelect.findIndex((x) => x === eventId)
            if (index !== -1) {
                this.eventSelect.splice(index, 1)
                this.eventInfo.splice(index, 1)
            } else {
                this.eventSelect.push(eventId)
                this.eventInfo.push({
                    name: item.draw_name,
                    date: item.draw_date,
                })
            }
        },
        // FreeBet: number of spins currently placed on a given draw.
        drawCount(eventId) {
            return this.eventSelect.filter((x) => x === eventId).length
        },
        // FreeBet: remove the most recent spin placed on this draw.
        onRemoveFreebetDraw(eventId) {
            for (let i = this.eventSelect.length - 1; i >= 0; i--) {
                if (this.eventSelect[i] === eventId) {
                    this.eventSelect.splice(i, 1)
                    this.eventInfo.splice(i, 1)
                    break
                }
            }
        },
        // FreeBet: dump every remaining spin onto this draw in one tap.
        onFillFreebetDraw(eventId, item) {
            const remaining = this.freebetRemainingToPick
            for (let i = 0; i < remaining; i++) {
                this.eventSelect.push(eventId)
                this.eventInfo.push({
                    name: item.draw_name,
                    date: item.draw_date,
                })
            }
        },

        handleBack() {
            this.$router.push('/loto')
        },

        renderDate(date) {
            const dateFormat = formatDateUTC00(date)
            const isCheckSameDay = isSameDay(date)
            return isCheckSameDay ? `${dateFormat.hour}H${dateFormat.minutes}` : `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}H${dateFormat.minutes}`
        },
        renderPrice(price, decimal) {
            return formatPrice(price, decimal)
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/loto/_index.scss';
</style>
